<h1 mat-dialog-title>Logout</h1>
<div mat-dialog-content>
  Willst du wirklich ausloggen?
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Nein</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ja</button>
</div>
